import styles from './IncidentList.module.css';
import Card from '../UI/card/Card';
import { Icon } from '@bookingcom/bui-react';
import { PopoutIcon } from '@bookingcom/bui-assets-react/streamline';
import { getRelativeTime } from '../../utils/utils';

interface ISingleIncident {
  incidentId: string;
  incidentUrl: string;
  created_at: string;
  assigneedEngineerName: Array<string>;
  incidentSummary: string;
  status: string;
}

interface IIncidentList {
  incidentList: Array<ISingleIncident>;
}

const IncidentList = ({ incidentList }: IIncidentList) => {
  return (
    <div>
      {incidentList.map((incident) => (
        <Card key={incident.incidentId} className={styles.incidentListCardContainer}>
          <p className={styles.onGoingIncidentText} data-testid={'OngoingIncidentTextTestId'}>
            Ongoing Incident(s)
          </p>
          <div className={styles.onGoingListContainer}>
            <a
              href={incident.incidentUrl}
              data-testid={'link' + incident.incidentId}
              target={'_blank'}
              rel="noopener noreferrer">
              <Icon svg={PopoutIcon} size={'large'} color={'disabled'} />
            </a>
            <p className={styles.incidentTimeText}>{getRelativeTime(incident.created_at)}</p>
            <div className={styles.incidentListInfoContainer}>
              <p className={styles.incidentIdDetails}>{incident.incidentSummary}</p>
              <p className={styles.incidentUserAssignedInfo}>
                Assigned to {incident.assigneedEngineerName[0]}
              </p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};
export default IncidentList;
